import { useContext } from "react";
import type { ModuleMountOptions } from "@opengov/psp-contract";
import { PspOptionsContext } from "./context";

export function usePspOptions(): ModuleMountOptions | null {
  return useContext(PspOptionsContext);
}
